import { useHistory, Redirect } from 'react-router-dom'

import { useFirebase, AuthModalHash } from '@scouts/auth'
import {
    colors,
    font,
    theme,
    Button,
    Container,
    Flexer,
    Heading,
    List,
    Page,
    ProductOverview,
    Spacer,
    Typography,
} from '@scouts/ui'

import { PATH_ROOT } from '@/constants'

import { SupportWidget } from '@/components/SupportWidget'

export const WelcomeStart = () => {
    const { user } = useFirebase()
    const history = useHistory()

    const isLoggedIn = !!user
    if (isLoggedIn) return <Redirect to={PATH_ROOT} />

    return (
        <Page>
            <Container tabletPadding="60px 0">
                <Flexer column gap="18px" tabletGap="60px">
                    <ProductOverview background={theme.primary.backgroundLight}>
                        <ProductOverview.Main>
                            <Spacer marginBottom="24px" tabletMarginBottom="36px">
                                <Flexer column gap="12px">
                                    <Heading
                                        family={font.family.display}
                                        size={font.display.large}
                                        tabletSize={font.display.medium}
                                        weight={font.weight.semiBold}
                                    >
                                        Adiós, estrés.
                                        <br />
                                        Hola, Taxfix.
                                    </Heading>

                                    <Typography variant="body">
                                        Te asignaremos un asesor fiscal personal que se encargará del papeleo y
                                        resolverá todas tus dudas.
                                    </Typography>
                                </Flexer>
                            </Spacer>
                            <Flexer column gap="12px">
                                <Button
                                    size="large"
                                    isFullWidth
                                    onClick={() => history.push({ hash: AuthModalHash.signup })}
                                >
                                    Empezar gratis
                                </Button>

                                <Button
                                    variant="tertiary"
                                    size="large"
                                    isFullWidth
                                    onClick={() => history.push({ hash: AuthModalHash.login })}
                                >
                                    Iniciar sesión
                                </Button>
                            </Flexer>
                        </ProductOverview.Main>
                        <ProductOverview.Description>
                            <List itemsBackground={colors.surface.base} itemsMargin="18px" itemsIcon="✓">
                                <List.Item>Asesor fiscal personal</List.Item>
                                <List.Item>Plataforma 100% online</List.Item>
                                <List.Item>Precio fijo y transparente</List.Item>
                            </List>
                        </ProductOverview.Description>
                    </ProductOverview>
                    <SupportWidget />
                </Flexer>
            </Container>
        </Page>
    )
}
